import { Resource } from './resource';
import { Source } from './source';
import { User } from './user';

export class Applicant extends Resource {
name:string;
firstName: String;
lastName :String;
email: String;
phone: String;
summary: String;
currentCtc: String;
currentTitle: String;
resumeUrl: String;
bonus: String;
fullName:String;
resumeFileName:String;
alternatePhone :string;
remarks :string;
alreadyInProcess:string;
sourceId : string;
referredById :string;
source :Source;
referredBy: User;
sourceType:any;
}